import {
  useNativeCurrency,
  useWrappedCurrency,
} from "@/app/blockchains/use-blockchain"
import { useQuery, useSuspenseQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { CollectionMoleculeReatom } from "./index.reatom"

export const useCollectionReatom = () => {
  const { collectionQueryParamsAtom } = useMolecule(CollectionMoleculeReatom)
  const queryParams = collectionQueryParamsAtom()
  const { data: collection } = useSuspenseQuery(queryParams)

  return collection
}

export const useCollectionStatisticReatom = () => {
  const { statisticQueryParamsAtom } = useMolecule(CollectionMoleculeReatom)
  const queryParams = statisticQueryParamsAtom()
  const { data: statistic } = useQuery(queryParams)

  return statistic
}

export const useCollectionBlockchainReatom = () => {
  const { blockchain } = useMolecule(CollectionMoleculeReatom)

  return blockchain
}

export const useCollectionNativeCurrencyReatom = () => {
  const { blockchain } = useMolecule(CollectionMoleculeReatom)
  const nativeCurrency = useNativeCurrency(blockchain)

  return nativeCurrency
}

export const useCollectionWrappedCurrencyReatom = () => {
  const { blockchain } = useMolecule(CollectionMoleculeReatom)
  const currency = useWrappedCurrency(blockchain)

  return currency
}
